import type { IconProps } from '../types/IconProps.ts';
export const ChevronsUpDown: IconProps = {
    name: 'ChevronsUpDown',
    children: [
        `<path d="m7 9 4.65-4.65c.2-.2.5-.2.7 0L17 9M7 15l4.65 4.65c.2.2.5.2.7 0L17 15" />`,
    ]
};